export enum Supplement43cLevel {
  SEVENTY_FIVE = 'SEVENTY_FIVE',
  FIFTY = 'FIFTY',
  THIRTY = 'THIRTY',
  FIFTEEN = 'FIFTEEN',
  NULL = 'NULL',
}

export function supplement43cLevelToPercentage(level: Supplement43cLevel): number {
  switch (level) {
    case Supplement43cLevel.SEVENTY_FIVE:
      return 75;
    case Supplement43cLevel.FIFTY:
      return 50;
    case Supplement43cLevel.THIRTY:
      return 30;
    case Supplement43cLevel.FIFTEEN:
      return 15;
    default:
      return 0;
  }
}

export function supplement43cLevelDropdown() {
  const supplementalLevelValues = Object.values(Supplement43cLevel);
  if (supplementalLevelValues) {
    return supplementalLevelValues.map((item) => ({
      label: `${supplement43cLevelToPercentage(item)} %`,
      value: item,
    }));
  } else return [];
}
